import { render } from "./downgrade-interstitial.vue?vue&type=template&id=55981d68&lang=pug"
import script from "./downgrade-interstitial.vue?vue&type=script&setup=true&lang=js"
export * from "./downgrade-interstitial.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__